var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from "@/api/ApiClient";
export const mergeAnonymousCartWithCustomerCart = () => __awaiter(void 0, void 0, void 0, function* () {
    if (apiClient.isMockMode()) {
        return null;
    }
    const anonymousCartId = localStorage.getItem("anonymousCartId");
    if (!anonymousCartId)
        return null;
    try {
        const { body: anonCart } = yield apiClient.publicApiRoot
            .withProjectKey({ projectKey: apiClient.publicProjectKey })
            .carts()
            .withId({ ID: anonymousCartId })
            .get()
            .execute();
        const { body: customerCart } = yield apiClient.publicApiRoot
            .withProjectKey({ projectKey: apiClient.publicProjectKey })
            .me()
            .activeCart()
            .get()
            .execute()
            .catch(() => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield apiClient.publicApiRoot
                .withProjectKey({ projectKey: apiClient.publicProjectKey })
                .me()
                .carts()
                .post({ body: { currency: "EUR" } })
                .execute();
            return res;
        }));
        const newItems = anonCart.lineItems.map((item) => ({
            action: "addLineItem",
            productId: item.productId,
            variantId: item.variant.id,
            quantity: item.quantity,
        }));
        console.log("Merging anonymous cart...");
        console.log("Anonymous cart ID:", anonymousCartId);
        console.log("Customer cart ID:", customerCart.id);
        console.log("Line items to move:", newItems);
        if (newItems.length > 0) {
            const { body: updatedCart } = yield apiClient.publicApiRoot
                .withProjectKey({ projectKey: apiClient.publicProjectKey })
                .me()
                .carts()
                .withId({ ID: customerCart.id })
                .post({
                body: {
                    version: customerCart.version,
                    actions: newItems,
                },
            })
                .execute();
            yield apiClient.publicApiRoot
                .withProjectKey({ projectKey: apiClient.publicProjectKey })
                .carts()
                .withId({ ID: anonCart.id })
                .delete({ queryArgs: { version: anonCart.version } })
                .execute();
            localStorage.removeItem("anonymousCartId");
            localStorage.removeItem("anonymousId");
            return updatedCart;
        }
        return customerCart;
    }
    catch (err) {
        console.error("Failed to merge anonymous cart:", err);
        return null;
    }
});
